<!-- <kendo-tilelayout class="student-dashboard" [columns]="3">
      <kendo-tilelayout-item [col]="1" >
        <kendo-tilelayout-item-header class="k-header-all k-header-other"><fa-icon icon="file-pen" class="fa-m blue-icon-color"></fa-icon> Programs </kendo-tilelayout-item-header>
        <kendo-tilelayout-item-body kendoTooltip title="Programs data is static. Data will flow from IEP going forward">
            <ng-container *ngFor="let program of studentIEP?.programs;">
                <div class="k-d-flex k-gap-2 k-w-full k-justify-content-center k-align-items-center">
                    <div class="k-flex-basis-3/4 k-d-flex k-w-30">
                        <strong>{{ program.mandateDescription }}</strong>
                    </div>
                    <div class="k-flex-basis-1/4 k-d-flex k-w-20">
                        <p><fa-icon icon="users-between-lines" class="fa-s k-pr-1"></fa-icon>{{ program.frequency }}<br/>
                              <fa-icon icon="language" class="fa-s k-pr-1"></fa-icon>{{ program.language }}</p>
                    </div>
                </div>
            </ng-container>
               
        </kendo-tilelayout-item-body>
      </kendo-tilelayout-item>

      <kendo-tilelayout-item [col]="2" >
        <kendo-tilelayout-item-header class="k-header-all k-header-other"><fa-icon icon="notes-medical" class="fa-m blue-icon-color"></fa-icon> Related Services</kendo-tilelayout-item-header>
        <kendo-tilelayout-item-body kendoTooltip title="Related Services data is static. Data will flow from IEP going forward">
            <ng-container *ngFor="let rs of studentIEP?.relatedServices;">
                <div class="k-d-flex k-gap-2 k-w-full k-justify-content-center k-align-items-center">
                    <div class="k-flex-basis-3/4 k-d-flex k-w-30">
                        <strong>{{ rs.mandateDescription }}</strong>
                    </div>
                    <div class="k-flex-basis-1/4 k-d-flex k-w-20">
                        <p><fa-icon icon="users-between-lines" class="fa-s k-pr-1"></fa-icon>{{ rs.frequency }}<br/>
                              <fa-icon icon="language" class="fa-s k-pr-1"></fa-icon>{{ rs.language }}</p>
                    </div>
                </div>
            </ng-container>
        </kendo-tilelayout-item-body>
      </kendo-tilelayout-item>

      <kendo-tilelayout-item [col]="3">
        <kendo-tilelayout-item-header class="k-header-all k-header-alert"><fa-icon icon="triangle-exclamation" class="fa-m"></fa-icon> Alerts</kendo-tilelayout-item-header>
        <kendo-tilelayout-item-body >
          
        </kendo-tilelayout-item-body>
      </kendo-tilelayout-item>
    </kendo-tilelayout>

    <kendo-tilelayout class="student-dashboard" [columns]="3">
      <kendo-tilelayout-item [col]="1">
        <kendo-tilelayout-item-header class="k-header-all k-header-other"><fa-icon icon="bus" class="fa-m blue-icon-color"></fa-icon> Transportation</kendo-tilelayout-item-header>
        <kendo-tilelayout-item-body kendoTooltip title="Transportation data is static. Data will flow from IEP going forward">
            <ng-container *ngFor="let transport of studentIEP?.transportation; let i=index">
                <strong>{{ transport.title }}</strong>
                <p>{{ transport.description }}</p>
            </ng-container>
        </kendo-tilelayout-item-body>
      </kendo-tilelayout-item>

      <kendo-tilelayout-item [col]="2" >
        <kendo-tilelayout-item-header class="k-header-all k-header-other"><fa-icon icon="universal-access" class="fa-m"></fa-icon> Assistive Technology</kendo-tilelayout-item-header>
        <kendo-tilelayout-item-body kendoTooltip title="Assistive Technology data is static. Data will flow from IEP going forward">
            <ng-container *ngFor="let at of studentIEP?.assistiveTechnology; let i=index">
                <strong>{{ at.title }}</strong>
                <p>{{ at.description }}</p>
            </ng-container>
        </kendo-tilelayout-item-body>
      </kendo-tilelayout-item>

      <kendo-tilelayout-item [col]="3">
        <kendo-tilelayout-item-header class="k-header-all k-header-other"><fa-icon icon="file" class="fa-m blue-icon-color"></fa-icon> Recent Documents</kendo-tilelayout-item-header>
        <kendo-tilelayout-item-body>
          <ng-container *ngFor="let sd of studentDocuments| slice:0:5">
            <div>          
            <fa-icon icon="file"></fa-icon> <a class="doc-name"
            (click)="viewDocument(sd)"> {{sd.documentName}} </a>

          </div>      
          </ng-container>          
        </kendo-tilelayout-item-body>
      </kendo-tilelayout-item>
    </kendo-tilelayout>

    <kendo-tilelayout class="student-dashboard" [columns]="3">
      <kendo-tilelayout-item [col]="1" [colSpan]="3">
        <kendo-tilelayout-item-header class="k-header-all k-header-other"><fa-icon icon="users" class="fa-m"></fa-icon> People</kendo-tilelayout-item-header>
        <kendo-tilelayout-item-body kendoTooltip title="IEP People data is static. Data will flow from IEP going forward">
          
            <h3>IEP Team</h3>
            <kendo-grid *ngIf="studentIEP && studentIEP.iepTeam" [kendoGridBinding]="studentIEP.iepTeam" scrollable="none" [resizable]="false">
                <kendo-grid-column field="role" title="Role" [width]="100"></kendo-grid-column>
                <kendo-grid-column field="name" title="Name" [width]="100" ></kendo-grid-column>
                <kendo-grid-column field="task" title="Task" [width]="200" ></kendo-grid-column>
                <kendo-grid-column field="taskStatus" title="Task Status" [width]="100" ></kendo-grid-column>
                <kendo-grid-column title="Actions" [width]="80" ></kendo-grid-column>
            </kendo-grid>
          
            <h3>Providers</h3>
            <kendo-grid *ngIf="studentIEP && studentIEP.providers" [kendoGridBinding]="studentIEP.providers" scrollable="none">
                <kendo-grid-column field="role" title="Role" [width]="100"></kendo-grid-column>
                <kendo-grid-column field="name" title="Name" [width]="100" [resizable]="false"></kendo-grid-column>
                <kendo-grid-column field="task" title="Task" [width]="200" [resizable]="false"></kendo-grid-column>
                <kendo-grid-column field="taskStatus" title="Task Status" [width]="100" [resizable]="false"></kendo-grid-column>
                <kendo-grid-column title="Actions" [width]="80" [resizable]="false" [innerText]=""><fa-icon icon="envelope" class="fa-m"></fa-icon></kendo-grid-column>
            </kendo-grid>
    
        </kendo-tilelayout-item-body>
      </kendo-tilelayout-item>
    </kendo-tilelayout>
 -->
<div class="dashboard k-d-flex k-flex-column k-gap-5">
  <app-student-programs *ngIf="studentIEP?.programs?.length > 0" title="Programs" [programs]="studentIEP?.programs"
    [studentIEP]="studentIEP">
  </app-student-programs>

  <app-student-programs *ngIf="studentIEP?.relatedServices?.length > 0" title="Related Services"
    [programs]="studentIEP?.relatedServices"  [studentIEP]="studentIEP">
  </app-student-programs>

  <app-student-programs *ngIf="studentIEP?.assistiveTech?.length > 0" title="Assistive Technology"
    [studentIEP]="studentIEP" [programs]="studentIEP?.assistiveTech" [studentIEP]="studentIEP">
  </app-student-programs>

  <app-student-programs *ngIf="studentIEP?.supplementaryAids?.length > 0" title="Supplementary Aids"
    [showFinalizedDate]="true" [studentIEP]="studentIEP" [programs]="studentIEP?.supplementaryAids"
    [studentIEP]="studentIEP">
  </app-student-programs>

  <app-student-programs *ngIf="studentIEP?.supportForSchoolPersonnel?.length > 0" title="Supports" [showMandate]="false"
    [studentIEP]="studentIEP" [programs]="studentIEP?.supportForSchoolPersonnel" [studentIEP]="studentIEP">
  </app-student-programs>

  <!-- TRANSPORTATION -->
  <kendo-card [width]="'100'" class="k-mb-2 k-mr-2">
    <kendo-card-header>
      <h4 class="subsection__heading">Transportation</h4>
    </kendo-card-header>
    <div class="separator !k-mb-6"></div>
    <kendo-card-body *ngIf="isPreSchool" class="k-p-4">
      <p>
        {{ studentIEP?.transportationDesc || "No Transportation to show" }}
      </p>
    </kendo-card-body>
    <kendo-card-body *ngIf="!isPreSchool" class="k-p-4">
      <div class="k-d-grid k-grid-cols-1 k-grid-cols-md-3 k-gap-4">
        <div>
          <h4 class="subsection__heading">Adult Supervision</h4>
          <p *ngFor="let item of adultSupervisionList" [hidden]="!item.condition()">
            {{ item.label }}
          </p>
        </div>
        <div>
          <h4 class="subsection__heading">Vehicle and/or Equipment Needs</h4>
          <p *ngFor="let item of vehicleEquipmentList" [hidden]="!transportationDetails?.[item.key]">
            {{ item.label }}
          </p>
        </div>
        <div>
          <h4 class="subsection__heading">Other Accommodations</h4>
          <p *ngFor="let item of otherAccommodationsList" [hidden]="!transportationDetails?.[item.key]">
            {{ item.label }}
          </p>

          <p *ngIf="transportationDetails?.specialAccommodationDesc">
            Reason for special transportation service and/or accommodations:{{
            transportationDetails.specialAccommodationDesc
            }}
          </p>
        </div>
      </div>
    </kendo-card-body>
  </kendo-card>

  <!-- MEDICAL -->
  <div class="student-programs">
    <kendo-card [width]="'100'" *ngIf="eligibilityResponse" class="k-mb-2 k-mr-2">
      <kendo-card-header>
        <h4 class="k-card-title">Medical</h4>
      </kendo-card-header>
      <kendo-card-body *ngIf="isPreSchool">
        <div>
          <p *ngIf="
              studentIEP?.medicalCondition || studentIEP?.physicalLimitation
            ">
            Medical / Physical information available
          </p>
          <p *ngIf="
              !studentIEP?.medicalCondition && !studentIEP?.physicalLimitation
            ">
            No Medical information to show
          </p>
        </div>
      </kendo-card-body>
      <kendo-card-body *ngIf="!isPreSchool">
        <div class="k-d-flex k-gap-6 medical-sections">
          <div class="k-flex-1">
            <h4 class="subsection__heading">The student has</h4>
            <div class="k-d-flex k-flex-column k-gap-1">
              <label class="k-checkbox-label" *ngFor="let item of studentHasSection">
                <input type="checkbox" kendoCheckBox [checked]="eligibilityResponse[item.key]" disabled />
                <p class="k-checkbox-text">{{ item.label }}</p>
              </label>
            </div>
          </div>

          <div class="k-flex-1">
            <h4 class="subsection__heading">Which affect their</h4>
            <div class="k-d-flex k-flex-column k-gap-1">
              <label class="k-checkbox-label" *ngFor="let item of affectsSection">
                <input type="checkbox" kendoCheckBox [checked]="eligibilityResponse[item.key]" disabled />
                <p class="k-checkbox-text">{{ item.label }}</p>
              </label>
            </div>
          </div>

          <div class="k-flex-1">
            <h4 class="subsection__heading">The student requires</h4>
            <div class="k-d-flex k-flex-column k-gap-1">
              <label class="k-checkbox-label" *ngFor="let item of studentRequiresSection">
                <input type="checkbox" kendoCheckBox [checked]="eligibilityResponse[item.key]" disabled />
                <p class="k-checkbox-text">{{ item.label }}</p>
              </label>
            </div>
          </div>
        </div>
      </kendo-card-body>
    </kendo-card>
  </div>
</div>